import {
  NinVerificationInput,
  NinVerificationRes,
  DriversLicenceVerificationRes,
  VoterCardVerificationRes,
} from "types/verification.type";
import { handleGetRequest, handlePostRequest } from "./http.service";

export const getAllVerificationOrders = async (status?: string) => {
  const query = status ? `?status=${status}` : "";
  return await handleGetRequest<any[]>(`/verification-services/admin/orders${query}`);
};

export const completeVerificationOrder = async (
  orderId: string,
  passed: boolean,
  details?: Record<string, any>
) => {
  return await handlePostRequest<{ passed: boolean; details?: any }, any>(
    `/verification-services/order/${orderId}/complete`,
    { passed, details: details || {} }
  );
};

export const verifyNin = async (
  input: NinVerificationInput,
  userId: string
) => {
  return await handlePostRequest<NinVerificationInput, NinVerificationRes>(
    `/verifications/verify-nin?userId=${userId}`,
    input
  );
};

export const verifyDriverLicence = async (
  licenceNumber: string,
  userId: string,
  type: string
) => {
  return await handlePostRequest<
    { licenceNumber: string; type: string },
    DriversLicenceVerificationRes["entity"]
  >(`/verifications/verify-driver-license?userId=${userId}`, {
    licenceNumber,
    type,
  });
};

export const verifyVoterCard = async (
  vin: string,
  userId: string,
  type: string
) => {
  return await handlePostRequest<
    { vin: string; type: string },
    VoterCardVerificationRes["entity"]
  >(`/verifications/verify-voter-card?userId=${userId}`, { vin, type });
};
